import React, { useContext } from 'react'

import { DealTemplatesStoreContext } from '../../contexts'
import { DealTemplatesStore } from '../../types'

const useDealTemplatesStore = (): DealTemplatesStore => {
   const dealTemplatesStore = useContext(DealTemplatesStoreContext)

   if (!dealTemplatesStore) {
      throw new Error('Expected to be wrapped in Deal Template Store Provider')
   }

   return dealTemplatesStore
}

export { useDealTemplatesStore }
